
/**
 * Class to implement device utilities
 */
export class Device
{
    /**
     * Checks for the iOS user-agent
     *
     * @returns {boolean}
     */
    public static get iOS(): boolean
    {
        return /iPad|iPhone|iPod/.test(navigator.userAgent);
    }
}
